import React from "react";
import "../../styles/TestCasesField.css";

// The code a "Code to compile with output" question's answer box starts with:
// the question's data, a function for the student to fill in, and the lines
// that read the input and print the result. Plain text — Tab indents rather
// than leaving the field, since Python depends on indentation.
const StarterCodeField = ({ value = "", onChange }) => {
  const onKeyDown = (e) => {
    if (e.key !== "Tab" || e.shiftKey) return;
    e.preventDefault();
    const el = e.target;
    const { selectionStart: start, selectionEnd: end } = el;
    const next = `${value.slice(0, start)}    ${value.slice(end)}`;
    onChange(next);
    requestAnimationFrame(() => { el.selectionStart = el.selectionEnd = start + 4; });
  };
  return (
    <div className="tcf-wrapper">
      <p className="tcf-hint">
        Shown in the student's answer box before they start. Keep the lines that read the input and print the
        result, so the output matches the test cases exactly; leave the logic for the student to write.
      </p>
      <label className="tcf-field">
        <textarea
          rows={10}
          value={value}
          spellCheck={false}
          placeholder={"def solve(numbers):\n    # Write your code here\n    pass\n\n\n# Do not change the code below\nnumbers = list(map(int, input().split()))\nprint(solve(numbers))"}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
        />
      </label>
    </div>
  );
};

export default StarterCodeField;
